<template>
	<div class="userList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">

				<el-form-item>
					<el-input size clearable v-model="searchForm.title" placeholder="请输入方案名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.up_code" placeholder="请输入方案编号"></el-input>
				</el-form-item>
				<!-- <el-form-item>
					<el-select size v-model="searchForm.status" clearable placeholder="请选择方案状态">
						<el-option label="有效" value="1"></el-option>
						<el-option label="无效" value="2"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="handleSearch(searchForm)">查询</el-button>

					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addPolicy()">添加调价政策</el-button>

					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addAgent()">添加代理商</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="userTable" size="mini" border style="width: 100%" v-loading="loading"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column header-align="center" align="center" fixed type="index" label="ID" min-width="80">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="title" label="方案名称" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="up_code" label="方案编号" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="up_type_text" label="涨价条件" min-width="150">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="net_value" label="商户入网天数/日期"
					min-width="150"></el-table-column>
				<el-table-column header-align="center" align="center" prop="max_monty" label="且交易量(元)"
					min-width="150">
						<template slot-scope="scope">
							<span v-if="scope.row.min_money != '—'">{{scope.row.min_money}} 一 {{scope.row.max_monty}}</span>
							
							<span v-else>{{scope.row.min_money}}</span>
						</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="rate_type_text" label="涨价方式"
					min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="new_update_rate" label="费率涨价值"
					min-width="120">
					<template slot-scope="scope">
						{{scope.row.new_update_rate}}
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="update_sec_fee" label="秒到费涨价值"
					min-width="150">
					<template slot-scope="scope">
						{{scope.row.update_sec_fee}}
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="nums" label="已涨价商户"min-width="150">
					<template slot-scope="scope">
						{{scope.row.nums}}
					</template>
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="mark" label="备注" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="status_text" label="状态" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="150">
				</el-table-column>
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click="renew(scope.row,2)" type="text" size="small" v-if="scope.row.status == 1">停用</el-button>
						<el-button @click="renew(scope.row,1)" type="text" style="color:#85ce61" size="small" v-if="scope.row.status == 2">启用</el-button>
						<el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper" style="text-align: center"></el-pagination>
		</el-card>

		<el-dialog title="添加调价政策" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
			<el-form :model="policyForm" size="small" label-width="120px" :rules="policyRules" ref="policyForm">
				<el-row>
					<el-col :span="10">
						<el-form-item label="方案名称" prop="title">
							<el-input size clearable v-model="policyForm.title" placeholder="请输入方案名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="涨价条件" prop="up_type">
							<el-select size v-model="policyForm.up_type" @change="condition">
								<el-option label="入网天数且交易量" :value="1"></el-option>
								<el-option label="入网日期且交易量" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12.5" v-if="conditionState == 1">
						<el-form-item label="商户入网天数" prop="net_day">
							<el-input size clearable v-model="policyForm.net_day" placeholder="请输入商户入网天数">
								<!-- <template slot="suffix">天</template> -->
							</el-input>
							<span style="margin-left:10px">天,且交易量</span>
						</el-form-item>
					</el-col>
					<el-col :span="12.5" v-if="conditionState == 2">
						<el-form-item label="商户入网天数" prop="net_date">
							<el-date-picker v-model="policyForm.net_date" type="date" value-format="yyyy-MM-dd"
								placeholder="选择日期">
							</el-date-picker>
							<span style="margin-left:10px">前,且交易量</span>
						</el-form-item>
					</el-col>
					<el-col :span="10" style="display: flex;justify-content: flex-start;align-items: center;">
						<el-form-item label-width="20px">
							<el-input size clearable v-model="policyForm.min_money" style="width:100px !important;" min="0" @input="policyForm.min_money=policyForm.min_money.replace(/^(0+)|[^\d]+/g,'')">
								<template slot="suffix">元</template>
							</el-input>
						</el-form-item>
						<span style="width: 5px;margin-top: -20px;margin-left: 10px;">一</span>
						<el-form-item label-width="20px">
							<el-input size clearable v-model="policyForm.max_monty" style="width:100px !important;"  min="0" @input="policyForm.max_monty=policyForm.max_monty.replace(/^(0+)|[^\d]+/g,'')">
								<template slot="suffix">元</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="费率涨价">
							<el-select size v-model="policyForm.rate_type">
								<el-option label="上涨" :value="1"></el-option>
								<el-option label="调至" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label-width="20px">
							<el-input size clearable v-model="policyForm.new_update_rate" @keyup.native="proving('new_update_rate')">
								<template slot="suffix">%</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="秒到费涨价">
							<el-select size v-model="mdf">
								<el-option label="调至" :value="1"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label-width="20px">
							<el-input size clearable v-model="policyForm.update_sec_fee" @keyup.native="proving('update_sec_fee')">
								<template slot="suffix">元</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20">
						<el-form-item label="备注">
							<el-input type="textarea" v-model="policyForm.mark" placeholder="请输入备注"
								:autosize="{ minRows: 3, maxRows: 10}"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="状态" prop="status">
							<el-select size v-model="policyForm.status">
								<el-option label="有效" :value="1"></el-option>
								<el-option label="无效" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="submitForm('policyForm')">确 定</el-button>
			</span>
		</el-dialog>


		<el-dialog title="添加代理" :visible.sync="agentDialogVisible" width="40%" :before-close="handleClose">
			<el-form :model="agentForm" size="small" label-width="120px"   :rules="agentRules" ref="agentForm">
				<el-row>
					<el-col :span="10">
						<el-form-item label="代理商编号"prop="agent_no" >
							<el-input size clearable v-model="agentForm.agent_no" placeholder="请输入代理商编号" @change="agentInput"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="代理商名称">
							<el-input size clearable v-model="agentForm.agent_name"  :disabled="true" placeholder="请输入代理商名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10">
						<el-form-item label="关联政策" prop="brand_id">
							<el-select size v-model="agentForm.brand_id">
								<el-option :label="item.brand_name" :value="item.brand_id" v-for="(item,index) in agentOptionList"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="是否关联下级" prop="is_next">
							<el-select size v-model="agentForm.is_next">
								<el-option label="是" :value="1"></el-option>
								<el-option label="否" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="agentSubmit('agentForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "creditCardaDjustment",
		data() {
			return {
				searchForm: {
					page: 1,
					limit: 10,
				},
				userTable: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: false,
				//添加方案 
				dialogVisible: false,
				conditionState: 1,
				policyForm: {
					up_type: 1,
					status: 1,
					rate_type: 1,
					min_money:0,
					max_monty:0,
				},
				mdf: 1,
				policyRules: {
					title: [{
						required: true,
						message: '请输入政策名称',
						trigger: 'blur'
					}, ],
					net_day: [{
						required: true,
						message: '请输入入网天数',
						trigger: 'blur'
					}, ],
					up_type: [{
						required: true,
						message: '请选择涨价条件',
						trigger: 'change'
					}],
					net_date: [{
						type: 'string',
						required: true,
						message: '请选择日期',
						trigger: 'change'
					}],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}]
				},
				//添加代理
				agentDialogVisible: false,
				agentForm: {
					is_next:0,
				},
				agentRules:{
					agent_no: [{
						required: true,
						message: '请输入代理商编号',
						trigger: 'blur'
					}, ],
					brand_id: [{
						required: true,
						message: '请选择关联政策',
						trigger: 'change'
					}],
					is_next: [{
						required: true,
						message: '请选择是否关联下级',
						trigger: 'change'
					}],
				},
				agentOptionList:[],
				multipleSelection:[],
			}
		},
		mounted() {
			this.getData({
				page: 1,
				limit: 10
			});
		},

		methods: {
			// 只能输入数字且只有一位小数
			proving(name) {
　　　　　　　　　 // this.form.skus[e].Price 是input的值　　
				// 先把非数字的都替换掉，除了数字和.
				this.policyForm.[name] = this.policyForm.[name].replace(/[^\d.]/g, '');
				// // 必须保证第一个为数字而不是.
				this.policyForm.[name] = this.policyForm.[name].replace(/^\./g, '');
				// // 保证只有出现一个.而没有多个.
				this.policyForm.[name] = this.policyForm.[name].replace(/\.{2,}/g, '');
				// // 保证.只出现一次，而不能出现两次以上
				this.policyForm.[name] = this.policyForm.[name].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
			},
			//添加代理商
			addAgent() {
				if(this.multipleSelection.length != 1){
					this.$message({
						type: 'info',
						message: '请勾选一条方案进行添加代理商',
						duration: 2000,
					})
				}else{
					this.agentDialogVisible = true;
					this.agentForm.up_policy_id = this.multipleSelection[0].id;
				}
			},
			//根据代理查询 政策
			agentInput(e){
				if(e){
					this.$api.post('terminal/RateUpPolicyUserBrandList',{agent_no:e}, res => {
						if (res.code == 0) {
							delete this.agentForm.brand_id;
							this.agentForm.agent_name = res.data.real_name;
							this.agentOptionList = res.data.list;
							
						} else {
							this.$message.error(res.msg);
						}
					})
				}
			},
			//保存代理商
			agentSubmit(formName){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('terminal/RateUpPolicyUserAdd', this.agentForm, res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								let params = this.searchForm;
								this.getData(params);
								this.frozenLoading = false;
								this.agentDialogVisible = false;
								this.agentForm = {
									is_next:0,
								};
								this.agentOptionList = [];
								
							} else {
								this.$message.error(res.msg);
								this.frozenLoading = false;
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//添加方案 
			addPolicy() {
				this.dialogVisible = true;
			},
			condition(e) {
				this.conditionState = e;
			},
			
			//添加方案  添加代理 公用一个关闭方法
			handleClose() {
				this.policyForm = {
					up_type: 1,
					status: 1,
					rate_type: 1,
					min_money:0,
					max_monty:0,
				};
				this.conditionState = 1;
				this.dialogVisible = false;
				
				this.agentForm = {
					is_next:0,
				};
				this.agentOptionList = [];
				this.agentDialogVisible = false;
			},
			//勾选数据
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//保存添加政策
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if(!this.policyForm.update_sec_fee && !this.policyForm.new_update_rate){
							this.$message({
								type: 'error',
								message: '请填写费率涨价或秒到费涨价',
								duration: 2000,
							})
							return false;
						}
						if(this.conditionState == 1){
							delete this.policyForm.net_date;
						}else{
							delete this.policyForm.net_day;
						}
						this.$api.post('terminal/RateUpPolicyAdd', this.policyForm, res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								let params = this.searchForm;
								this.getData(params);
								this.frozenLoading = false;
								this.policyForm = {
									up_type: 1,
									status: 1,
									rate_type: 1,
									min_money:0,
									max_monty:0,
								};
								this.conditionState = 1;
								this.dialogVisible = false;
							} else {
								this.$message.error(res.msg);
								this.frozenLoading = false;
							}
						})

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//停用
			renew(row,val) {
				let text = val == 1?'确定启用?':'确定停用';
				this.$confirm(text, '提 示', {
					type: 'warning',
					distinguishCancelAndClose: true,
					confirmButtonText: '确 定',
					cancelButtonText: '取 消'
				}).then(() => {
					let data = {
						id: row.id,
						status: val,
					};
					this.frozenLoading = true; //防重复
					this.$api.post('terminal/RateUpPolicyStatusChange', data, res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
								duration: 2000,
							})
							let params = this.searchForm;
							this.getData(params);
							this.frozenLoading = false;
						} else {
							this.$message.error(res.msg);
							this.frozenLoading = false;
						}
					})
				}).catch(() => {

				})
			},
			handleSearch(searchForm) { //搜索
				this.currentPage = 1;
				searchForm.page = 1;
				this.getData(searchForm);
			},
			handleInfo(row) { //详情
				this.$router.push({
					path: '/policyDetails',
					query: {
						id: row.id
					}
				});
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("terminal/RateUpPolicyList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.total = data.count; //总数
						this.userTable = data.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	};
</script>

<style scoped>
	.el-input,
	.el-select {
		width: 180px !important;
	}
</style>
